define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/query",
	"csi",
	"csi/heading/stateColorResolver",
	"csi/html",
	"csi/html/StateWidget",
	"csi/locale",
	"csi/xml"
], function(declare,domClass,query,csi,stateColorResolver,html,StateWidget,locale,xml) {

return declare(StateWidget, {
		_processHtml: function(/*csi.def.Context*/ctx, /*DOMNode*/dom) {
			// summary: process each element with a key according to its matching definition
			this.inherited(arguments);
			
			var node = ctx.getNode();
			var eDraft = query(".draft", dom)[0];
			var eActive = query(".active", dom)[0];
			var eInactive = query(".inactive", dom)[0];
			
			const css = stateColorResolver.getStateCss(node);
			const stateEnumValue = xml.enumGetText(node.State);
			
			switch (stateEnumValue) {
				case "Draft": domClass.add(eDraft, css); break;
				case "Active": domClass.add(eActive, css); break;
				case "Inactive": domClass.add(eInactive, css); break;
			}

			html.text(eDraft, locale.getEnumName("ProductStructureState:Draft", true));
			html.text(eActive, locale.getEnumName("ProductStructureState:Active", true));
			html.text(eInactive, locale.getEnumName("ProductStructureState:Inactive", true));
		}
	});
});